import * as React from "react";
import "./styles/spinner.less";

export interface LoadingProps {
    label?: string;
    style?: any;
}

export const Loading: React.SFC<LoadingProps> = (props) => {
    return <div className="centered-container">
        <div className="loading-spinner">
            <svg className="spinner" width="65px" height="65px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                <circle className="path" fill="none" strokeWidth="6" strokeLinecap="round" cx="33" cy="33" r="30"/>
            </svg>
            <label>{props.label}</label>
        </div>
    </div>;
};

Loading.defaultProps = {
    label: "Loading"
};

export const LoadingOverlay: React.SFC<LoadingProps> = (props) => {
    return <div style={props.style} className="loading-overlay"><Loading {...props} /></div>;
};

LoadingOverlay.defaultProps = Loading.defaultProps;



// WEBPACK FOOTER //
// ./src/components/Loading.tsx